import { generateClient } from "aws-amplify/api";
import { getDocumentByProductId, getDocumentByQRId } from "../graphql/queries";
import { updateGeneratedDocument } from "../graphql/mutations";

const client = generateClient();

const documentService = {
  getDocumentByProductId: async (productId) => {
    const response = await client.graphql({
      query: getDocumentByProductId,
      variables: { productId },
      authMode: "userPool",
    });
    if (response.data?.getDocumentByProductId?.items?.length > 0) {
      return response.data?.getDocumentByProductId?.items?.reduce((a, b) => {
        return new Date(a.createdDate).getTime() >
          new Date(b.createdDate).getTime()
          ? a
          : b;
      });
    } else {
      return undefined;
    }
  },
  getDocumentByQRId: async (QuestionnaireResponseId) => {
    try {
      const response = await client.graphql({
        query: getDocumentByQRId,
        variables: { QuestionnaireResponseId },
        authMode: "userPool",
      });
      return response.data?.getDocumentByQRId?.items || [];
    } catch (e) {
      // console.log("e", e);
    }
  },
  updateDocumentIsNew: async () => {
    let documents = await documentService.getDocument();
    documents = documents?.filter((item) => item.isNew === true);
    for (const document of documents) {
      await client.graphql({
        query: updateGeneratedDocument,
        variables: {
          input: {
            id: document.id,
            isNew: false,
          },
        },
        authMode: "userPool",
      });
    }
  },
};

export default documentService;
